
import { getItemAttributes } from "@rista/core/helpers/catalogueHelpers";
import { METHODS, REACT_NATIVE_APP_EVENTS } from "data/constants";
import _ from "lodash";
import { MOST_SOLD_SUB_CATEGORY, LARGE_CATALOG_CATEGORY, MAPPING_PREVENT_BRANCH_ID, MAPPING_PREVENT_BRANCH_NAME } from "utils/constants";
import { isNumber } from "utils/validator";
import store from "../redux-store/index";
import { channelItemMapDetail, getBizBrandsData, getItemTag, getMostSoldItems, getPOSSettingsData, } from '../redux-store/slices/catalogueSlice';
import { isOffline } from '../facade/ServiceFacade';
import { getUsers } from '../redux-store/slices/TableViewSlice';

import { fetchCommonData } from "redux-store/slices/common";
import { ENDPOINT } from "config/endpoints";
import { convertArrayToObject, getBranchId } from "./commonHelpers";
import { getCurrentSoldOutItemSuccess } from "redux-store/slices/ItemStatusSlice";
import { getBusinessDataObj, getUserDataObj } from "redux-store/slices/BusinessSlice"
import { CHEF_RECOMMENDED_SUBCAT, ITEMS_CONST } from "utils/constants";
import { setCatalogueRefetch } from "../redux-store/slices/ItemsSlice";
import { getAllOutlets } from "redux-store/slices/OutletStatusSlice";
import { sendDataToApp } from "utils/nativeHooks";
import { catalogHelpers } from "@dotpe/rista-pos-common";
import { fetchOfflineUsers } from "redux-store/slices/LoginSlice";
import { getRecommenderConfig } from "redux-store/slices/RecommenderSlice";

const ITEM_TYPES = {
  variant: "Variant",
  group: "Group"
};

// Moved to @rista/core (web variant returns null on empty input; mobile returns {}).
// Re-export only: this file's last internal caller was populateOptionSetVariantWrapper, which
// moved to core with it.
export { arrayToMap } from "@rista/core/helpers/catalogueHelpers";
// Moved to @rista/core/helpers/catalogueHelpers (index.desktop.ts — the two platforms' bodies are
// entirely different: this one has an offline/online split with a deferred second wave, the other
// fans out to sixteen calls unconditionally). Re-exported only; nothing in this file's own body
// calls it.
export { fetchCatalogCompleteData } from "@rista/core/helpers/catalogueHelpers";

export function getRecommendedSubCategories() {
  const chefRecommendedMid = findMidOfChefRecommended();
  return [
    {
        "name": "Chef Recommended",
        "descripton": "Chef Recommended Items",
        "displayOrder": 2,
        "mid": chefRecommendedMid
    },
    {
        "name": "Most sold Items",
        "descripton": "Most Sold Items",
        "displayOrder": 1,
        "mid": MOST_SOLD_SUB_CATEGORY
    }
]
} 

export function getDiscountedCode(selectedDeal: any, dealsObject: any, itemData: any) {
  const matchingDealId =
    selectedDeal && Array.isArray(selectedDeal) &&
    selectedDeal?.find((dealId) => {
      const deal = dealsObject[dealId];
      let discounttype = deal && deal?.discountType;
      let checkItemIds =
        deal && deal?.itemIds && deal?.itemIds?.includes(itemData?.mid);
      if (checkItemIds) {
        return true;
      }
      let checkCategoryIds =
        deal &&
        deal?.categoryIds &&
        deal?.categoryIds?.includes(itemData?.categoryId);

      if (checkCategoryIds) {
        return true;
      }
      //Deals of type BuyX/Y, Get X/Y type have itemIds and categoryIds in buyInfo
      let checkBuyXTypeItems =
        deal &&
        deal?.[discounttype]?.buyInfo?.itemIds &&
        deal?.[discounttype]?.buyInfo?.itemIds?.includes(itemData?.mid);

      if (checkBuyXTypeItems) {
        return true;
      }
      let checkBuyXTypeCats =
        deal &&
        deal?.[discounttype]?.buyInfo?.categoryIds &&
        deal?.[discounttype]?.buyInfo?.categoryIds?.includes(
          itemData?.categoryId
        );

      if (checkBuyXTypeCats) {
        return true;
      }

      let applicableForAllDeals =
        deal &&
        !deal?.[discounttype]?.buyInfo &&
        !deal?.itemIds &&
        !deal?.categoryIds;

      return applicableForAllDeals;
    });
  return matchingDealId ? dealsObject[matchingDealId]?.discountCode : '';
}

// Moved to @rista/core/helpers/catalogueHelpers (both are WEB variants there).
// `getItemAttributes` is imported as well as re-exported because getItemDataForCatalog below
// still calls it; `itemsMidMapForBarcode` diverges from mobile's and lives in index.desktop.ts.
export { itemsMidMapForBarcode } from "@rista/core/helpers/catalogueHelpers";
export { getItemAttributes };

export function sortCatalogueItems(catalogue: any) {
  let newCatalogue = { ...catalogue };
  for (let catagoryId in newCatalogue) {
    let allItems = catalogue[catagoryId].items || [];
    let subCatItems = getAllItemsFromSubCats(
      catalogue[catagoryId]?.subCategories
    );
    allItems = allItems.concat(subCatItems);
    newCatalogue[catagoryId] = {
      ...catalogue[catagoryId],
      items: sortByDisplayOrder(allItems),
    };
  }
  return newCatalogue;
}

// Moved to @rista/core/helpers/catalogueHelpers.
//   shared.ts        -> getOptionVariantForChannel, setPriorityForItemTags (byte-identical in
//                       both apps; they had only ever been uplifted on the mobile side)
//   index.desktop.ts -> getItemPrice, getItemDataForCatalog, isItemValidForChannel,
//                       parseCatagories, parseMenu (all genuinely divergent from mobile's)
//
// getItemDataForCatalog and getItemPrice are IMPORTED as well as re-exported because this
// file's own body still calls them — an `export ... from` re-export creates NO local binding
// (ledger rule 5 / hazard 30).
export {
  getItemPrice,
  getItemDataForCatalog,
  isItemValidForChannel,
  parseCatagories,
  parseMenu,
  getOptionVariantForChannel,
  setPriorityForItemTags,
} from "@rista/core/helpers/catalogueHelpers";
import { getItemDataForCatalog, getItemPrice } from "@rista/core/helpers/catalogueHelpers";

// Moved to @rista/core/helpers/catalogueHelpers (WEB-ONLY — mobile has no equivalent).
// Its private `populateOptionSetVariant` went with it; `window.RL.common.round2` is reached
// through the effects bridge's `getWindow()` there.
export { populateOptionSetVariantWrapper } from "@rista/core/helpers/catalogueHelpers";

export function getSaleNotes() {
  return (!!store.getState().catalogStore?.posSettings?.saleNotes?.length ? store.getState().catalogStore.posSettings.saleNotes : [])
}

export function getChannelDefData(channelDefId: any) {
  let channelDefData = !!store.getState().catalogStore?.channelDef?.length ? store.getState().catalogStore.channelDef : [],
    index = channelDefData.findIndex((channel: any) => channel.mid === channelDefId);
  const branchId = store.getState()?.businessStore?.businessData?.branchId;
  if (!!channelDefData?.[index]) {
    let channelData = channelDefData[index];
    if (channelData?.variants?.length) {
      // check for channel variant
      channelData = catalogHelpers.handleChannelVariant(channelData, branchId);
    }
    return channelData;
  }
  return {};
}

function findMidOfChefRecommended() {
    let tagsData = store.getState().catalogStore.itemTags;
    for (const key in tagsData) {
        if (tagsData[key].name === CHEF_RECOMMENDED_SUBCAT) {
            return tagsData[key].mid;
        }
    }
    return null;
}

// Moved to @rista/core/helpers/catalogueHelpers (shared.ts — logic-identical in both apps)
// together with getImageUrl below. Re-exported so this file's importers are unchanged; neither
// symbol is referenced in this file's own body, so no accompanying import is needed (rule 5).
export { checkTag, getImageUrl } from "@rista/core/helpers/catalogueHelpers";

// Moved to @rista/core/helpers/catalogueHelpers (shared.ts). Pulled up by the MyOrderCard
// dependency closure; both apps' copies differed only in brace style. Re-exported so this
// file's importers are unchanged — not referenced in this file's own body (rule 5).
export { getAggregatorLogo } from "@rista/core/helpers/catalogueHelpers";


export function focusBarCodeScan() {
  setTimeout(() => {
    let elem = document.querySelector(".barcode-search-view-page"),
      inputElem = elem?.querySelector(".input-cnt");
    if (inputElem) {
      (inputElem as HTMLElement).focus();
    }
  }, 10);
}

export function getPaymentIconsUrl(imagePath = "") {
  let baseURL = process.env.REACT_APP_RISTA_EXTERNAL_PAYMENT_ICON, result = "";
  console.log("process.env:  ", process.env);
  if (imagePath) {
    result = `${baseURL}/${imagePath}`;
  }
  return result;

}

/* this function takes all the tags defined for the bussiness and set the priorities of tags in an array in a specific order */

/**
* order items accoring to exact match
* @param {any} resultsData
* @param {string} searchValue
* @return {Object} filteredExactMatch
*/
export const handleItemOrder = (resultsData: any, value: any) => {
  let filteredExactMatch: any = {},
      otherMatchs: any = {};
    if (isNumber(value)) {
      filteredExactMatch = Object.keys(resultsData)
        .filter((keyId) => {
          if (resultsData[keyId]?.skuCode === value) {
            return resultsData[keyId];
          } else {
            otherMatchs[keyId] = resultsData[keyId];
          }
        })
        .reduce((obj: any, key: any) => {
          obj[key] = resultsData[key];
          return obj;
        }, {});
    } else {
      filteredExactMatch = Object.keys(resultsData)
        .filter((keyId) => {
          if (resultsData[keyId]?.name.toLowerCase() === value.toLowerCase()) {
            return resultsData[keyId];
          } else {
            otherMatchs[keyId] = resultsData[keyId];
          }
        })
        .reduce((obj: any, key: any) => {
          obj[key] = resultsData[key];
          return obj;
        }, {});
    }
    return filteredExactMatch = { ...filteredExactMatch, ...otherMatchs };
}

/**
* search items using channelItemsMidBarcodeMapping
* @param {string} searchvalue
* @return {Object} resultsData
*/
export const searchItemFromMenu = (value: any) => {
  let resultsArr: any[] = [],
    resultsData: any = {};
  const selectedChannel = store.getState().saleDataStore?.selectedChannelData;
  const itemsData = store.getState().itemsStore?.itemsData || {};
  const itemSchedules = store.getState().catalogStore?.scheduleData || [];
  const branchTimeZoneId = store.getState().businessStore?.businessData?.timeZone?.zoneId;
  const branchId = getBranchId();
  const soldOutItemsList = store.getState().ItemsStatusStore?.soldOutItemsList || [];
  const itemsSearchMap = store.getState().itemsStore?.channelItemsMidBarcodeMapping,
    itemsSearchList = Object.keys(itemsSearchMap);
  if (value) {
    value = value.toLowerCase();
    resultsArr = itemsSearchList.filter((element) => element.includes(value));
  }
  resultsArr.map((val) => {
    const mid = itemsSearchMap[val];
    const item = itemsData[mid];
    if (!item) return;
    resultsData[mid] = getItemDataForCatalog(item, {
      channelData: selectedChannel,
      itemSchedules,
      branchTimeZoneId,
      branchId,
      soldOutItemsList,
    });
  });
  return resultsData;
};

export function getAllItemsFromSubCats(subCats: any) {
  let items: any[] = [];
  let subcats: any[] = Object.values(subCats || {});
  subcats.forEach((subCat) => {
    items = items.concat(subCat.items);
  });
  return items;
}

/**
 * This function will sort the categories and the sub categories in ascending order by displayorder key
 * @param {*} categoriesList 
 */
export function sortCategories(categoriesList: any) {
  let catList = structuredClone(categoriesList);
  // this function will return the sorted array based on displayOrderKey. It will create a sorted map based upon display order and then fetch the values from the map
  const newCatList = sortByDisplayOrder(catList);
  newCatList.forEach(element => {
    if (element.subCategories && element.subCategories.length) {
      const sortedSubCats = sortByDisplayOrder(element.subCategories);
      element.subCategories = sortedSubCats;
    }
  });
  return newCatList;
}

export const sortByDisplayOrder = (ipArr: any, dataMap: any = {}): any[] => {
  let sortedMap: any = {}, count = 0;
  for (let item of ipArr) {
    let itemOrder = item.displayOrder || `displayOrder${count++}`;
    if(Object.keys(dataMap)?.length) {
      itemOrder = dataMap[item]?.displayOrder || `displayOrder${count++}`;
    }
    if (sortedMap[itemOrder])
      sortedMap[itemOrder].push(item);
    else
      sortedMap[itemOrder] = [item];
  }
  return Object.values(sortedMap).flat();
};
export function handleModalScenarios({isDeliveryEnabled, isPickupEnabled, isOrderLabelReq, isCustInfoEnabled}: any){
  // Define UI scenarios for each flag combination
  const uiScenarios: any = {
    '0000': {},
    '0001': {deliveryModal: true, info: "", addressField: false, dineInModal: false, detailedCust: true},
    '0010': {deliveryModal: false, info: "", addressField: false, dineInModal: true, detailedCust: false},
    '0011': {deliveryModal: true, info: "", addressField: false, dineInModal: true, detailedCust: true},
    '0100': {deliveryModal: true, info: "pickup", addressField: false, dineInModal: false, detailedCust: false},
    '0101': {deliveryModal: true, info: "pickup", addressField: false, dineInModal: false, detailedCust: true},
    '0110': {deliveryModal: true, info: "pickup", addressField: false, dineInModal: true, detailedCust: false},
    '0111': {deliveryModal: true, info: "pickup", addressField: false, dineInModal: true, detailedCust: true},
    '1000': {deliveryModal: true, info: "delivery", addressField: true, dineInModal: false, detailedCust: false},
    '1001': {deliveryModal: true, info: "delivery", addressField: true, dineInModal: false, detailedCust: true},
    '1010': {deliveryModal: true, info: "delivery", addressField: true, dineInModal: true, detailedCust: false},
    '1011': {deliveryModal: true, info: "delivery", addressField: true, dineInModal: true, detailedCust: true},
    '1100': {deliveryModal: true, info: "delivery", addressField: true, dineInModal: false, detailedCust: false},
    '1101': {deliveryModal: true, info: "delivery", addressField: true, dineInModal: false, detailedCust: true},
    '1110': {deliveryModal: true, info: "delivery", addressField: true, dineInModal: true, detailedCust: false},
    '1111': {deliveryModal: true, info: "delivery", addressField: true, dineInModal: true, detailedCust: true},
  };

  let uiScenario = {};

// Function to handle UI scenarios based on flag combination
  function handleUI(delivery: any, pickup: any, orderLabel: any, customerInfo: any) {
    let flags = '';

    // Convert the flags to a binary string
    flags += delivery ? '1' : '0';
    flags += pickup ? '1' : '0';
    flags += orderLabel ? '1' : '0';
    flags += customerInfo ? '1' : '0';

    console.log('Handling UI for:', flags);

    // Get the corresponding UI scenario based on the flag combination
    uiScenario = uiScenarios[flags];

    if (uiScenario) {
      console.log('UI Scenario:', uiScenario);
    } else {
      console.log('Invalid flag combination');
    }
  }

  // Example usage
  handleUI(isDeliveryEnabled, isPickupEnabled, isOrderLabelReq, isCustInfoEnabled);
  return uiScenario;
}

export function checkRenderDeliveryDineModal(modalRenderObj: any, saleData: any) {
  if (modalRenderObj?.detailedCust) {
    return (
      !saleData?.customerInfo || !Object.keys(saleData?.customerInfo)?.length
    );
  }
  if (
    modalRenderObj?.deliveryModal &&
    (!saleData?.deliveryInfo || !Object.keys(saleData?.deliveryInfo)?.length)
  ) {
    return true;
  }
  if (
    modalRenderObj?.dineInModal &&
    (!saleData?.serviceLabel || !Object.keys(saleData?.serviceLabel)?.length)
  ) {
    return true;
  }
  return false;
}

/**
 * This function will get the list of most sold items it will get called once in a day
 */
function getMostSoldItemsList() {
  const branchId = store.getState().businessStore?.businessData?.branchId;
  // call function to get most sold items only one time in a day or if most sold items list is empty
  if (needsMostSoldItemsFetch()) {
    store.dispatch(getMostSoldItems({ branchId: branchId }));
  }
}

/**
 * 
 * @param {*} obj
 * @param {*} itemList
 * @param {*} keyToSearch
 * check if list of items are present in given object if present then push items data in the list
 * else search for items recursively
 */
function recursiveSearch(obj: any, itemList: any, keyToSearch: any) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      if ( keyToSearch && key === `${keyToSearch}` && Array.isArray(value)) {
        itemList.push(...value);
      }

      if (typeof value === "object" && value !== null) {
        recursiveSearch(value, itemList, keyToSearch);
      }
    }
  }
}

/**
 * 
 * @param {*} data 
 * get Catalaog Items to render and return the list of items
 */
function getAllItems(data: any) {
  const itemList: any[] = [];
  recursiveSearch({ ...data }, itemList, ITEMS_CONST);
  return itemList;
}

// Returns items for Recommended sub categories (Chef Recommended and Most Sold)
export function getRecommendedSubCategoryItems( // TODO: need to be improved in future
  catalogDataToRender: any
) {
  const allItemsMap = store.getState().itemsStore.itemsData || {};
  const allItems = getAllItems(catalogDataToRender);
  const allItemsSet = new Set([...allItems]);
  const chefRecommendedMid = findMidOfChefRecommended();
  const mostsolditems = store.getState().catalogStore.mostSoldItems || [];
  let uniqueMids: any;

  // CHEF RECOMMENDED
  uniqueMids = new Set();
  let chefRecommendedSubCatItems = allItems.filter((itemId) => {
    if (
      allItemsMap[itemId]?.info?.tagIds?.includes(chefRecommendedMid) &&
      !uniqueMids.has(itemId)
    ) {
      uniqueMids.add(itemId);
      return true;
    }
    return false;
  });
  // const chefRecommendedVariantItems = allItems.filter( // TODO: To be added in future after fixing
  //   (item) =>
  //     item?.info?.tagIds?.includes(chefRecommendedMid) &&
  //     item?.type === ITEM_TYPES.variant
  // );
  // let groupItems = [];
  // chefRecommendedVariantItems.forEach((itemData) => { // add parent item for chef recommended variant items
  //   if (!uniqueMids.has(itemData?.parentItemId)) {
  //     uniqueMids.add(itemData?.parentItemId);
  //     groupItems.push(allItemDataMap[itemData?.parentItemId]);
  //   }
  // });
  // chefRecommendedSubCatItems = [...chefRecommendedSubCatItems, ...groupItems];

  // most sold
  let mostSoldSubCatItems: any[] = [];
  uniqueMids = new Set();
  mostsolditems.forEach((item: any) => {
    if (!uniqueMids.has(item?.itemId) && allItemsSet.has(item?.itemId)) {
      uniqueMids.add(item?.itemId);
      mostSoldSubCatItems.push(item?.itemId);
    }
  });
  return {
    [chefRecommendedMid]: chefRecommendedSubCatItems,
    [MOST_SOLD_SUB_CATEGORY]: mostSoldSubCatItems
  };
}
// Part of approach 2 not needed for now
// function createChannelIdItemMap(channelIds  = []){
//   const mapObject = {}
//    channelIds?.forEach((id) => {
//     mapObject[id] = {}
//    })
//    return mapObject;
// }

// export function createCompleteChannelItemMap(
//   allItems,
//   allChannelData
// ) {
//   if(!(allItems?.length || allChannelData?.length)) return;

//   const itemsData = store.getState()?.itemsStore?.itemsData || {},
//   channelIdMap = arrayToMap(allChannelData, 'channelId'),
//   channelIdArray = Object.keys(channelIdMap),
//   newChannelIdItemsMap = createChannelIdItemMap(channelIdArray);
//   allItems.forEach(item => {
//         let baseItemDataToSet = {
//           name: item.info.longName,
//           imageURL: item.info.imageURL,
//           imageDataId: item.info.imageDataId,
//           imagePath: item.info.imagePath,
//           mid: item.mid,
//           description: item.info.description,
//           categoryId: item.info.categoryId,
//           hasItemVariants: !!item.variantIds?.length,
//           hasItemOptions: !!item.priceInfo?.optionSetIds?.length,
//           price: 0,
//           type: item.type,
//           subCategoryId: item.info?.subCategoryId || '',
//           menuIds: item.info?.menuIds ? [...item.info?.menuIds] : [],
//           displayOrder: itemsData[item.mid]?.displayOrder || undefined,
//           ...item,
//         };
//         if (item?.info?.categoryId) {
//           let subCategoryId = item?.info?.subCategoryId;
//             item?.channelIds?.forEach((id) => {
//               if(!newChannelIdItemsMap[id][item?.info?.categoryId]) {
//               newChannelIdItemsMap[id][item?.info?.categoryId] =  {
//                 subCats: {},
//                 items: [],
//                 parentCatItems: [],
//               };
//               }
//             })
//           // if (subCategoryId) {
//           //   if (
//           //     channelIdToItemMap[item?.info?.categoryId].subCats?.[
//           //     subCategoryId
//           //     ]
//           //   ) {
//           //     channelIdToItemMap[item?.info?.categoryId].subCats?.[
//           //       subCategoryId
//           //     ]?.items.push(baseItemDataToSet);
//           //   } else {
//           //     channelIdToItemMap[item?.info?.categoryId].subCats = {
//           //       ...channelIdToItemMap[item?.info?.categoryId].subCats,
//           //       [subCategoryId]: {
//           //         items: [baseItemDataToSet],
//           //       },
//           //     };
//           //   }
//           // } 
//           // else
//           //   channelIdToItemMap[item?.info?.categoryId].parentCatItems.push(
//           //     baseItemDataToSet,
//           //   );

//           // channelIdToItemMap[item?.info?.categoryId].items.push(
//           //   baseItemDataToSet,
//           // );
//           item?.channelIds?.forEach((id) => {
//             const updateBaseItem = cloneDeep(baseItemDataToSet);
//             newChannelIdItemsMap[id][item?.info?.categoryId].parentCatItems.push(baseItemDataToSet);
//             newChannelIdItemsMap[id][item?.info?.categoryId].items.push(baseItemDataToSet);
//             let itemPrice;
//             item?.priceInfo?.prices?.map(priceObj => {
//               //making channelDefId obj for an item with their minimum price for that channel
//               if (priceObj?.channelIds === id)
//                 itemPrice = itemPrice
//                   ? Math.min(itemPrice, priceObj.price)
//                   : priceObj.price;
//               // if (priceObj.price || priceObj.price === 0) {
//               //   if (priceToChannelMap[priceObj.channelDefId] !== undefined && priceToChannelMap[priceObj.channelDefId] > priceObj.price)
//               //     priceToChannelMap[priceObj.channelDefId] = priceObj.price;
//               //   else
//               //     priceToChannelMap[priceObj.channelDefId] = priceObj.price;
//               // }
//             });
//             updateBaseItem.price = itemPrice;
//           })
//         }
//         /**
//          * Running loop over priceToChannelMap and mapping all the channelDefId to channelToItemMap and adding item to their correspoding
//          * categories and sub categories correspoding to that channel
//          */
//         // for (let channelDefId in priceToChannelMap) {
//         //   if (!channelToItemMap[channelDefId]) {
//         //     channelToItemMap[channelDefId] = {};
//         //   }

//         // }
//         // }
//   });
//   store.dispatch(channelItemMapDetail(newChannelIdItemsMap));
// }

export function getChannelToItemIdMap(
  allItems: any,
  currentChannelObj: any = {},
) {
  if (!currentChannelObj?.channelId) return;
  let channelId = currentChannelObj?.channelId,
    channelIdToItemMap: any = {};
  allItems.forEach((item: any) => {
    //setting the item to their corresponding channels
    let isPushItem = item.type !== ITEM_TYPES.variant
    if (isPushItem) {
      if (item?.channelIds?.includes(channelId)) {
        const itemId = item.mid;
        if (item?.info?.categoryId) {
          let subCategoryId = item?.info?.subCategoryId;
          if (!channelIdToItemMap[item?.info?.categoryId]) {
            //base structure for categories
            channelIdToItemMap[item?.info?.categoryId] = {
              subCats: {},
              items: [],
              parentCatItems: [],
            };
          }
          if (subCategoryId) {
            if (
              channelIdToItemMap[item?.info?.categoryId].subCats?.[
              subCategoryId
              ]
            ) {
              channelIdToItemMap[item?.info?.categoryId].subCats?.[
                subCategoryId
              ]?.items.push(itemId);
            } else {
              channelIdToItemMap[item?.info?.categoryId].subCats[subCategoryId] = { items: [itemId] }
            }
          } else {
            channelIdToItemMap[item?.info?.categoryId].parentCatItems.push(
              itemId,
            );
          }
          channelIdToItemMap[item?.info?.categoryId].items.push(
            itemId,
          );
        }
      }
    }
  });
  return channelIdToItemMap;
}

export function getChannelItemsList(
  allItems: any,
  currentChannelObj: any = {},
) {
  if (!currentChannelObj?.channelId) return;
  const channelId = currentChannelObj.channelId;
  const channelItemsList = [];

  for (let item of allItems) {
    // skip variants early
    if (item.type === ITEM_TYPES.variant) continue;

    const channelIds = item.channelIds;
    if (!channelIds || channelIds.indexOf(channelId) === -1) continue;

    const info = item.info;
    if (!info || !info.categoryId) continue;

    channelItemsList.push(item.mid);
  }
  return {
    [LARGE_CATALOG_CATEGORY]: {
      items: channelItemsList,
      parentCatItems: channelItemsList,
      subCats: {
      }
    }
};
}

/**
 * 
 * @param {*} categories[] 
 * @returns flat items list as itemIds
 */
// Moved to @rista/core/helpers/catalogueHelpers (shared.ts — byte-identical in both apps).
// IMPORTED as well as re-exported because getCurrentSoldOutItemsFn below CALLS it, and a
// re-export creates no local binding (ledger rule 5 / hazard 30).
export { flatItemsFromCategories } from "@rista/core/helpers/catalogueHelpers";
import { flatItemsFromCategories } from "@rista/core/helpers/catalogueHelpers";

export function getCurrentSoldOutItemsFn(params: any) {
  if(isOffline()) return;
  let payload: any = { branchId: getBranchId() };
  payload.callback = (response: any) => {
    sendDataToApp({
      eventName: REACT_NATIVE_APP_EVENTS.soldOutItemDetail,
      data: flatItemsFromCategories(response)
    });
  }
  store.dispatch(
    fetchCommonData({
    method: METHODS.POST,
    body: payload,
    url: ENDPOINT.ITEMSTATUS.getCurrentSoldOutItems(),
    action: getCurrentSoldOutItemSuccess,
    skipGlobalLoader: params?.skipGlobalLoader || false,
  }));
}

// Moved to @rista/core/helpers/catalogueHelpers (shared.ts). Reads the store through core's
// core's own store instead of this file's `store` singleton — user decision, 2026-08-21.
export { isDisplayOutOfStockItem } from "@rista/core/helpers/catalogueHelpers";

// returns item data to be shown on catalog // TODO: this func might be removed in future

// Moved to @rista/core (catalog/posCard, re-exported by helpers/catalogueHelpers).
// The two private helpers it used — isNonGroupItemAvailableInSchedule / isGroupItemAvailableInSchedule
// — moved with it and stayed private there. Core imports catalog_util from the @dotpe/rista-library
// PACKAGE, so the version there no longer depends on `window.RL` having been loaded first.
export { isItemAvailableInSchedule } from "@rista/core/helpers/catalogueHelpers";

export function populateMenuChannel(
  channelCategoryMap: any,
  allItemsData: any,
  menuId: any,
  channelId: any
) {
  const channelCats = channelCategoryMap[channelId];
  if (!channelCats) return;

  const filteredCats: any = {};

  for (const [catId, cat] of Object.entries<any>(channelCats)) {
    const filteredSubCats: any = {};
    const collectedSubItems: any[] = [];

    // --- Filter subcategories & collect items
    for (const [subId, sub] of Object.entries<any>(cat.subCats ?? {})) {
      const subItems = sub.items?.filter((itemId: any) =>
        allItemsData[itemId]?.info?.menuIds?.includes(menuId)
      );
      if (subItems?.length) {
        filteredSubCats[subId] = { items: subItems };
        collectedSubItems.push(...subItems);
      }
    }

    // --- Filter parent category direct items
    const filteredParentCatItems = cat.parentCatItems?.filter((itemId: any) =>
      allItemsData[itemId]?.info?.menuIds?.includes(menuId)
    ) ?? [];

    // --- Combine all items (direct + subcat items)
    const allItems = [...filteredParentCatItems, ...collectedSubItems];

    // --- Only keep category if it has any items
    if (allItems?.length) {
      const newCat: any = {
        parentCatItems: filteredParentCatItems,
        items: allItems,
      };
      newCat.subCats = filteredSubCats;
      filteredCats[catId] = newCat;
    }
  }

  return filteredCats;
}

// Moved to @rista/core (catalog/posCard, re-exported by helpers/catalogueHelpers) so that
// MOBILE can run the same projection — the Suggestive Selling flow now shares this pipeline.
// ⚠️ SIGNATURE CHANGED: the six positional catalogue arguments are now one `context` object,
// `getCatalogItemsFromIds(itemIds, context, filterConfig)`. Its only caller was the
// `useCatalogItemsFromIds` hook, which moved to
// @rista/core/catalog/hooks/usePosCatalogItems.
export { getCatalogItemsFromIds } from "@rista/core/helpers/catalogueHelpers";

/**
 * Is this one of the branches whose catalogue is too heavy to render synchronously?
 *
 * Both parameters are REQUIRED, deliberately. Converting this file to TypeScript surfaced a call
 * site in `Containers/NewOrder/NewOrder.tsx` (the cart column) that passed NOTHING, so
 * `includes(undefined)` was false and it always returned false there — the cart rendered
 * immediately on a heavy branch while the menus 34 lines above it deferred. That was a slip; the
 * call site now passes `businessData.branchId` / `.branchName` like the other three, and keeping
 * the params required is what stops it happening again.
 */
export function checkForHeavyItemsBusiness(branchId: any, branchName: any) {
  if (MAPPING_PREVENT_BRANCH_ID.includes(branchId) && MAPPING_PREVENT_BRANCH_NAME.includes(branchName)) {
    return true;
  }
  return false
}

// Moved to @rista/core/helpers/catalogueHelpers — re-exported so importers are unchanged.
export { getChannelData } from "@rista/core/helpers/catalogueHelpers";

// Moved to @rista/core/helpers/catalogueHelpers (index.desktop.ts — web-only; the most-sold
// feature and its two state fields exist only on this platform's catalogueSlice).
// 🔴 IMPORTED as well as re-exported: this file calls needsMostSoldItemsFetch() in its own body
// (fetchCatalogCompleteData's sibling at line ~472), and an `export ... from` re-export creates
// NO local binding. This is a `.js` file, so tsc would NOT have caught it — found by grepping the
// body for the symbol, which ledger rule 5 requires on every re-export.
import { needsMostSoldItemsFetch } from "@rista/core/helpers/catalogueHelpers";
export { needsMostSoldItemsFetch };
